import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Helpers } from './../../helpers/helpers';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
//see https://jasonwatmore.com/post/2019/06/14/angular-8-reactive-forms-validation-example
@Component({
  selector: 'app-sign-up-password',
  templateUrl: './sign-up-password.component.html',
  styleUrls: ['./sign-up-password.component.scss']
})
export class SignUpPasswordComponent implements OnInit {

  sectionTitle = 'Create You Account'
  policyAgreement = 'I agree to the terms and privacy policy'
  SUPasswordFormInfo = [
    {
      for: 'signUpPasswordEmail',
      label: 'Email address',
      type: 'email',
      className: 'form-control',
      id: 'signUpPasswordEmail',
      placeHolder: 'Enter email'
    },
    {
      for: 'signUpPassword',
      label: 'Password',
      type: 'password',
      className: 'form-control',
      id: 'signUpPassword',
      placeHolder: 'Enter Password'
    },
    {
      for: 'signUpPasswordConfirm',
      label: 'Confirm Password',
      type: 'password',
      className: 'form-control',
      id: 'signUpPasswordConfirm',
      placeHolder: 'Confirm Password'
    },
  ]

  singUpForm: FormGroup;
    submitted = false;

  constructor(private formBuilder: FormBuilder,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private router: Router) { }

  ngOnInit() {
    this.singUpForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      acceptTerms: [false, Validators.requiredTrue],
      activated:[false],
      Id:[''],
      lastUpdate:[new Date()]
  }, {
      validator: Helpers.MustMatch('password', 'confirmPassword')
  });
  }

  // convenience getter for easy access to form fields
  get f() { return this.singUpForm.controls; }

  async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.singUpForm.invalid) {
        return;
    }
    this.singUpForm.controls["lastUpdate"].setValue(new Date());
    // display form values on success
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.singUpForm.value, null, 4));
    let pp = JSON.stringify(this.singUpForm.value)
      //alert(JSON.stringify(pp));
      //This is our local "API". Data is beng stored and called from a JSON stored in application local variable.
      let id = await this.zenplansTestDataProviderService.addItem(pp,"users");
      alert('Success :-)');
      //this.goto('sign-up-completed/'+id);
      this.router.navigateByUrl('sign-up-completed/'+id);
}
goto(url: string) {
  this.submitted = false;
  this.router.navigate(['/' + url]);
}

onReset() {
    this.submitted = false;
    this.singUpForm.reset();
}


}
